import React from "react";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../../../Utils/renderField/renderReadField";

const FILAS = [
    { clave: "kg_humedos", etiqueta: "Kg húmedos" },
    { clave: "kg_secos", etiqueta: "Kg secos" },
    { clave: "drc", etiqueta: "DRC" },
];

// El DRC de cada columna son sus kg secos entre sus kg húmedos, así que se puede
// comprobar dividiendo las dos celdas de arriba. Cuando alguna de sus cargas
// todavía no tiene DRC el cociente saldría diluido, y en su lugar se marca
const CeldaResumen = ({ columna, clave }) => {
    if (clave !== "drc") {
        return <RenderKilogramo value={columna[clave]} decimalScale={2} />;
    }

    if (columna.drc === null) {
        return (
            <span
                className="tancadas-turno__badge-sin-drc"
                title="Hay cargas sin DRC: el DRC de la columna no se puede calcular"
            >
                Sin DRC
            </span>
        );
    }

    return <RenderNumberPercentage value={columna.drc} decimalScale={2} />;
};

// Una columna por almacén que se usó en el turno y dos de totales: la primera
// deja fuera el reproceso, que vuelve a producción ya seco, y la segunda lo
// incluye
export const ResumenTancadasTurno = ({ resumen }) => {
    const almacenes = resumen.almacenes;

    if (almacenes.length === 0) {
        return (
            <div className="text-center py-3 mb-4">
                No hay cargas registradas en el turno
            </div>
        );
    }

    return (
        <div className="new-table-wrapper mb-4">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th className="cell-border-right"></th>
                        {almacenes.map((almacen) => (
                            <th key={almacen.id}>{almacen.nombre}</th>
                        ))}
                        <th className="cell-border-left">
                            Total sin reproceso
                        </th>
                        <th>Total/total</th>
                    </tr>
                </thead>
                <tbody>
                    {FILAS.map((fila) => (
                        <tr key={fila.clave}>
                            <td className="text-center font-weight-bold cell-border-right">
                                {fila.etiqueta}
                            </td>

                            {almacenes.map((almacen) => (
                                <td
                                    key={almacen.id}
                                    className="text-center text-nowrap"
                                >
                                    <CeldaResumen
                                        columna={almacen}
                                        clave={fila.clave}
                                    />
                                </td>
                            ))}

                            <td className="text-center text-nowrap font-weight-bold cell-border-left">
                                <CeldaResumen
                                    columna={resumen.total_sin_reproceso}
                                    clave={fila.clave}
                                />
                            </td>
                            <td className="text-center text-nowrap font-weight-bold">
                                <CeldaResumen
                                    columna={resumen.total_general}
                                    clave={fila.clave}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
